import { NotificationChannel as SchemaNotificationChannel } from '@/schema'

import type { NotificationChannel, NotificationPreferenceConfig } from './types'

export const NOTIFICATION_CHANNELS: Array<{
  value: NotificationChannel
  labelKey: string
}> = [
  {
    value: SchemaNotificationChannel.EMAIL,
    labelKey: 'notificationSettings.channels.email',
  },
  {
    value: SchemaNotificationChannel.IN_APP,
    labelKey: 'notificationSettings.channels.inApp',
  },
  {
    value: SchemaNotificationChannel.BOTH,
    labelKey: 'notificationSettings.channels.both',
  },
  {
    value: SchemaNotificationChannel.NONE,
    labelKey: 'notificationSettings.channels.none',
  },
]

export const NOTIFICATION_PREFERENCE_CONFIGS: NotificationPreferenceConfig[] = [
  {
    key: 'comments.new_comment',
    apiKey: 'comment_new',
    category: 'comments',
    titleKey: 'notificationSettings.preferences.newComment.title',
    descriptionKey: 'notificationSettings.preferences.newComment.description',
    defaultValue: SchemaNotificationChannel.BOTH,
  },
  {
    key: 'comments.comment_resolved',
    apiKey: 'comment_resolved',
    category: 'comments',
    titleKey: 'notificationSettings.preferences.commentResolved.title',
    descriptionKey:
      'notificationSettings.preferences.commentResolved.description',
    defaultValue: SchemaNotificationChannel.BOTH,
  },
  {
    key: 'comments.mentions',
    apiKey: 'comment_mention',
    category: 'comments',
    titleKey: 'notificationSettings.preferences.mentions.title',
    descriptionKey: 'notificationSettings.preferences.mentions.description',
    defaultValue: SchemaNotificationChannel.BOTH,
  },
  {
    key: 'deadlines.deliverable_deadline_reminders',
    apiKey: 'workflow_deadline',
    category: 'deadlines',
    titleKey:
      'notificationSettings.preferences.deliverableDeadlineReminders.title',
    descriptionKey:
      'notificationSettings.preferences.deliverableDeadlineReminders.description',
    defaultValue: SchemaNotificationChannel.BOTH,
  },
  {
    key: 'assignments.deliverable_assignment_changes',
    apiKey: 'deliverable_assign',
    category: 'assignments',
    titleKey:
      'notificationSettings.preferences.deliverableAssignmentChanges.title',
    descriptionKey:
      'notificationSettings.preferences.deliverableAssignmentChanges.description',
    defaultValue: SchemaNotificationChannel.BOTH,
  },
]

export const PREFERENCES_BY_CATEGORY = {
  comments: NOTIFICATION_PREFERENCE_CONFIGS.filter(
    (c) => c.category === 'comments'
  ),
  deadlines: NOTIFICATION_PREFERENCE_CONFIGS.filter(
    (c) => c.category === 'deadlines'
  ),
  assignments: NOTIFICATION_PREFERENCE_CONFIGS.filter(
    (c) => c.category === 'assignments'
  ),
} as const

export const PREFERENCE_CATEGORIES: Array<{
  id: 'comments' | 'deadlines' | 'assignments'
  labelKey: string
}> = [
  { id: 'comments', labelKey: 'notificationSettings.categories.comments' },
  { id: 'deadlines', labelKey: 'notificationSettings.categories.deadlines' },
  {
    id: 'assignments',
    labelKey: 'notificationSettings.categories.assignments',
  },
]

export const QUERY_KEY_NOTIFICATION_PREFERENCES = 'notification-preferences'

export const NOTIFICATION_PREFERENCES_QUERY_KEY = () =>
  [QUERY_KEY_NOTIFICATION_PREFERENCES] as const

export const NOTIFICATION_PREFERENCES_STALE_TIME = 10 * 60 * 1000 // 10 minutes
